import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import { empty, type FirestoreMedia } from '../firestore/Media/schema'
import type { FirebaseRepository } from './FirebaseRepository'

export class Media extends ObservableModelWithDecorators<FirestoreMedia> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreMedia>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
